import { createDisplayResolver } from "./createDisplayResolver";

export const STORE_TYPE_CONFIG = {
  FLAGSHIP_STORE: {
    i18nKey: "store_locator.store_types.flagship_store",
  },
  BRAND_STORE: {
    i18nKey: "store_locator.store_types.brand_store",
  },
  POP_UP_STORE: {
    i18nKey: "store_locator.store_types.pop_up_store",
  },
  TOBACCONIST: {
    i18nKey: "store_locator.store_types.tobacconist",
  },
  TOBACCONIST_WITH_VENDING_MACHINE: {
    i18nKey: "store_locator.store_types.tobacconist_with_vending_machine",
  },
  DUTY_FREE: {
    i18nKey: "store_locator.store_types.duty_free",
  },
  VENDING_MACHINE: {
    i18nKey: "store_locator.store_types.vending_machine",
  },
  BARS_CAFES_RESTAURANTS: {
    i18nKey: "store_locator.store_types.bars_cafes_restaurants",
  },
  BAR_TOBACCONIST: {
    i18nKey: "store_locator.store_types.bar_tobacconist",
  },
  BAR_TOBACCONIST_WITH_VENDING_MACHINE: {
    i18nKey: "store_locator.store_types.bar_tobacconist_with_vending_machine",
  },
} as const;

const LEGACY_STORE_TYPE_MAP = {
  flagshipstore: "FLAGSHIP_STORE",
  brandstore: "BRAND_STORE",
  popupstore: "POP_UP_STORE",
  tobacconist: "TOBACCONIST",
  tobacconistwithvendingmachine: "TOBACCONIST_WITH_VENDING_MACHINE",
  dutyfree: "DUTY_FREE",
  vendingmachine: "VENDING_MACHINE",
  barscafesrestaurants: "BARS_CAFES_RESTAURANTS",
  bartobacconist: "BAR_TOBACCONIST",
  bartobacconistwithvendingmachine: "BAR_TOBACCONIST_WITH_VENDING_MACHINE",
} as const;

const storeTypeResolver = createDisplayResolver(STORE_TYPE_CONFIG, LEGACY_STORE_TYPE_MAP);

export type StoreTypeId = keyof typeof STORE_TYPE_CONFIG;
export const normalizeStoreTypeKey = storeTypeResolver.normalizeKey;
export const resolveStoreTypeId = storeTypeResolver.resolveId;
export const getStoreTypeDisplay = storeTypeResolver.getDisplay;
